import { Transition } from "@headlessui/react";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { XIcon } from "lucide-react";
import { Fragment, useEffect, useState } from "react";
import useTranslation from "@babackapp/translations/use-translation";

const bannerStyles = `
  @keyframes gradient {
    0% { background-position: 0% 50%; }
    33% { background-position: 100% 50%; }
    66% { background-position: 50% 50%; }
    100% { background-position: 0% 50%; }
  }
`;

export default function TrackingBanner() {
  const [isOpen, setIsOpen] = useState(false);
  const t = useTranslation();

  useEffect(() => {
    setTimeout(() => {
      setIsOpen(true);
    }, 1000);
  }, []);

  const onClose = () => {
    setIsOpen(false);
  };

  const handleDemoClick = () => {
    window.open("https://calendly.com/baback_/discovery", "_blank");
  };

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: bannerStyles }} />
      <Transition
        show={isOpen}
        as={Fragment}
        enter="transition ease-in-out duration-250"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition ease-in-out duration-250"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="bg-gradient-to-r from-blue-500 via-indigo-500 via-purple-500 via-blue-600 to-indigo-600 bg-[length:300%_100%] animate-[gradient_20s_ease-in-out_infinite] text-white fixed top-0 left-0 right-0 h-16 z-50 flex flex-row justify-center items-center space-x-4 px-4">
          <div className="flex-1 flex flex-row justify-center items-center space-x-4">
            <div className="text-center">{t("banner.tracking.message")}</div>
            <button
              type="button"
              className="inline-flex cursor-pointer justify-center items-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-white text-base font-medium text-blue-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm space-x-2 transition-colors"
              onClick={handleDemoClick}
            >
              <div>{t("banner.tracking.demoButton")}</div>
              <ArrowRightIcon className="w-4 h-4" />
            </button>
          </div>
          <button
            onClick={onClose}
            className="hover:bg-white/20 rounded p-1 transition-colors"
          >
            <XIcon className="w-4 h-4" />
          </button>
        </div>
      </Transition>
    </>
  );
}
